import { Utils } from '@gv/triage-components';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiQuery } from 'store/query';
import { generateUrl } from 'utils/helpers';
import { providesList, cacheByIdArg } from 'utils/query-cache';

import {
  Client,
  ClientData,
  ClientsRequest,
  ClientResponse,
  GetClientResponse,
  UpdateClientPayload,
} from './types';

const tagType = 'BitwerxClients';
export const cardsTag = 'BitwerxCards';
export const paymentClientTag = 'PaymentBitwerxClients';
export const clientsBitwerxApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'clientsBitwerxApi',
  tagTypes: [tagType, cardsTag, paymentClientTag],
  endpoints: (build) => ({
    bitwerxUpdate: build.mutation<Client, UpdateClientPayload>({
      transformResponse: (response: GetClientResponse) => response.data,
      invalidatesTags: (result, error, { client_id }) =>
        cacheByIdArg(tagType)(result, error, client_id),
      query: ({ client_id, ...data }) => ({
        data,
        method: 'put',
        url: generateUrl(URL.UPDATE_CLIENT, { id: client_id }),
      }),
    }),

    bitwerxList: build.query<ClientData, ClientsRequest>({
      providesTags: (result) => providesList(tagType)(result?.rows),
      transformResponse: (response: ClientResponse) => response.data,
      query: ({ search, page = 1, limit = 20, hospitalId }) => {
        const offset = Utils.Helpers.offset(page, limit);
        const searchParams = {
          limit,
          offset,
          search,
          hospitalId,
        };
        const url = Utils.Query.addParamsToUrl(
          URL.GET_CLIENT_LIST,
          searchParams
        );

        return {
          url,
          method: 'get',
        };
      },
    }),
  }),
});
export const { useBitwerxListQuery, useBitwerxUpdateMutation } =
  clientsBitwerxApi;

export { tagType as clientsTags };
